import type { JSX } from "react";
import type { NavItemProps } from "./nav-item/nav-item";
import { Drawer, css, styled } from "@mui/material";
import { useState } from "react";
import { CloseIcon, HamburgerMenuIcon } from "../../atoms/icons/mui-icons";
import { NAV_BUTTON_NO_CLOSE_MENU_ATTR_NAME, NavButton } from "./nav-item/nav-button";
import { SingleNavItem } from "./nav-item/nav-item";


const NavMenuDrawer = styled(Drawer)(({ theme }) => css`
	z-index: ${theme.zIndex.appBar - 1};

	.MuiDrawer-paper {
		display: flex;
		flex-direction: column;
		margin-block-start: ${theme.layout.navBarHeight};

		background-color: ${theme.palette.dark.main};
		color: ${theme.palette.dark.contrastText};
	}
`);

export type NavMenuCollapsedProps = {
	items: readonly NavItemProps[];
};
/**
 * Main nav menu for smaller screens.
 */
export const NavMenuCollapsed = ({ items }: NavMenuCollapsedProps): JSX.Element => {
	const [ open, setOpen ] = useState(false);

	const toggleOpen = () => {
		setOpen(!open);
	};

	const drawerId = "navMenuDrawer";

	return (
		<>
			<NavButton
				labelKey={ open ? "common:close" : "common:menu" }
				icon={ open ? CloseIcon : HamburgerMenuIcon }
				onClick={ toggleOpen }
				iconOnly
				aria-controls={ open ? drawerId : undefined }
				aria-haspopup="true"
				aria-expanded={ open ? "true" : undefined }
			/>
			<NavMenuDrawer
				id={ drawerId }
				anchor="top"
				open={ open }
				onClose={ () => setOpen(false) }
				onClickCapture={ (ev) => {
					if(ev.target instanceof HTMLElement) {
						if(ev.target.hasAttribute(NAV_BUTTON_NO_CLOSE_MENU_ATTR_NAME)) {
							return;
						}
					}
					setOpen(false);
				} }
			>
				{ items.map(i => <SingleNavItem { ...i } key={ i.labelKey } collapsed/>) }
			</NavMenuDrawer>
		</>
	);
};